import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
  Signal,
  computed,
  effect,
  inject,
  input,
  runInInjectionContext,
} from '@angular/core'

import { FlxStyleModule, FlxThemeModule, FlxWrapperStyleDirective } from '@flowx/angular-theme'
import { FlxSeparatorComponent } from '@flowx/angular-ui-toolkit'
import { SeparatorTemplateConfig } from '@flowx/core-sdk'

import { getBoolExpressionSignal } from '../helpers'

@Component({
  selector: 'flx-separator-wrapper',
  hostDirectives: [
    { directive: FlxWrapperStyleDirective, inputs: ['flxWrapperStyle: templateConfig'] },
  ],
  imports: [FlxSeparatorComponent, FlxThemeModule, FlxStyleModule],
  templateUrl: './separator-wrapper.component.html',
  styleUrl: './separator-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxSeparatorWrapperComponent implements OnInit, AfterViewInit {
  #injector = inject(Injector)
  #flxWrapperStyle = inject(FlxWrapperStyleDirective)

  templateConfig = input.required<SeparatorTemplateConfig>()

  displayOptions = computed(() => this.templateConfig().displayOptions)
  flowxProps = computed(() => this.displayOptions().flowxProps)
  style = computed(() => this.displayOptions().style)

  // expressions
  isHidden: Signal<boolean>

  ngOnInit(): void {
    runInInjectionContext(this.#injector, () => {
      const { hide } = this.flowxProps()
      this.isHidden = getBoolExpressionSignal(hide, this.templateConfig(), { logType: 'hide' })
    })
  }

  ngAfterViewInit(): void {
    runInInjectionContext(this.#injector, () => {
      effect(() => {
        this.#flxWrapperStyle.toggleDisplay(this.isHidden())
      })
    })
  }
}
